import { CreateProductDataRequest } from '@entities/product/api/product-types';
import { MutateFormFields } from '../ui/modal-mutate-product/types';
import dayjs from 'dayjs';
import { fileSearchToFileUpdateData } from '@shared/lib/utils/file-search-to-file-update-data/file-search-to-file-update-data';

export const normalizeSubmitValues = async (values: MutateFormFields): Promise<CreateProductDataRequest> => {
    const [startAt, endAt] = values.date.value?.match(/((\d+\.?)+)/g) || ['', ''];
    const images = await fileSearchToFileUpdateData(values.image);
    const files = await fileSearchToFileUpdateData(values.files);

    return {
        name: values.name,
        description: values.description,
        productInfoUrl: values.productInfoUrl,
        code: values.code,
        active: values.active === 'true',
        price: values.price,
        isPriceUndefined: values.withoutPrice,
        place: values.place,
        typeId: Number(values.type[0].value),
        catalogs: values.catalogs.map((catalog) => catalog.value).join(','),
        isEmailDomainRestricted: values.emailDomainRestricted,

        /* CRM */
        crmInterestCode: values.crmInterestCode[0]?.value,
        crmProductExternalId: values.crmProductExternalId[0]?.value,
        crmNeedOpportunity: values.crmNeedOpportunity,

        textOrderSuccess: values.textOrderSuccess,
        textOrderFail: values.textOrderFail,
        imageFiles: images.localFiles,
        imageAddIds: images.addIds,
        imageDeleteIds: images.deleteIds,
        files: files.localFiles,
        fileAddIds: files.addIds,
        fileDeleteIds: files.deleteIds,
        sort: Number(values.sort || 0),
        ...(startAt && { startAt: dayjs.utc(startAt, 'DD.MM.YYYY').startOf('D').format() }),
        ...(endAt && { endAt: dayjs.utc(endAt, 'DD.MM.YYYY').endOf('D').format() }),
    };
};
